var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClaimIconSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 60,
    viewBox: "0 0 75 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1896_120882",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 60,
    rx: 6,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1896_120882)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 54,
    r: 52,
    fill: "#FFB801"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0692 3.70423C56.6754 3.3156 56.0408 3.32067 55.6532 3.71556L35.57 24.1767C35.1845 24.5694 34.5541 24.5769 34.1594 24.1933L26.1366 16.3969C25.7398 16.0112 25.1053 16.0212 24.7207 16.419L16.6932 24.7233C16.3101 25.1196 16.3199 25.7513 16.7152 26.1354L34.3846 43.3065C34.7792 43.6901 35.4097 43.6826 35.7952 43.2899L65.3014 13.2283C65.6875 12.8349 65.6825 12.2032 65.2901 11.816L57.0692 3.70423Z",
    fill: "#FFE8AC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimIconSocial);
export default __webpack_public_path__ + "static/media/claim-icon-social.c789e9a8b7315bea764c0887a3c184e4.svg";
export { ForwardRef as ReactComponent };